var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.linkClass},[_c('a',{attrs:{"href":_vm.mNbr},on:{"click":function($event){$event.preventDefault();return _vm.aClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }